import React from "react";

// styles
import "../styles/App.css";

// header / footer
import GlobalHeader from "./GlobalHeader";
import GlobalFooter from "./GlobalFooter";

const Layout = ({ children }) => (
	<div className="app">
		<header>
			<GlobalHeader />
		</header>
		<div className="app-body">{children}</div>
		<div className="app-footer">
			<GlobalFooter />
		</div>
	</div>
);

export default Layout;
